// Comprehensive Import Wizard - Support for all import types with enhanced validation
import React from 'react';
import UploadWizard from '@/features/imports/UploadWizard';

export default function UploadPage() {
  return (
    <div className="min-h-screen" data-tour-target="import-page">
      <UploadWizard />
    </div>
  );
}
